import type { Security } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';

export const getSecurityMachineFunctionByType: {
  [Type in Security.SecurityType]: (
    deviceSecurity: Security.DeviceSecurity,
  ) => Security.SecurityMachine | null;
} = {
  acl: prop('machineAcl'),
  // machineCloud is optional; coalesce undefined to null to match the signature.
  cloud: (deviceSecurity) => deviceSecurity.machineCloud ?? null,
  nat44: prop('machineNat44'),
  pbr: prop('machinePbr'),
  zoneFw: prop('machineZones'),
};
